import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('gu'); // Default: Gujarati

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'gu' ? 'en' : 'gu');
  };

  const t = (content) => {
    if (typeof content === 'object' && content !== null) {
      return content[language] || content.en || content;
    }
    return content;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
